import paths from './paths';
import UserProfile from 'screens/user/UserProfile';
import Wallet from 'screens/user/Wallet';
import AffiliateProgram from 'screens/user/AffiliateProgram';
import UserReservations from 'screens/user/UserReservations';

export default [
    {
        exact: true,
        path: paths.user.profile,
        element: <UserProfile />
    },
    {
        exact: true,
        path: paths.user.wallet,
        element: <Wallet />
    },
    {
        exact: true,
        path: paths.user.affiliate,
        element: <AffiliateProgram />
    },
    {
        exact: true,
        path: paths.user.reservations,
        element: <UserReservations />
    }
]